module.exports = __webpack_public_path__ + "static/media/illustration-living-room.79e122be.png";